import { InputSelect, Stack } from '@eneco/sparky';

import { useAddressOptions } from '../hooks/useAddressOptions';

export const AddressFilter = ({ label, onFocus }: { label: string; onFocus?: () => void }) => {
  const { addressOptions, addressIdentifier, setAddressIdentifier } = useAddressOptions();

  if (addressOptions && addressOptions.length > 1) {
    return (
      <Stack.Item grow>
        <InputSelect
          label={label}
          name="location"
          options={addressOptions}
          placeholder=""
          value={addressIdentifier || ''}
          onChange={e => {
            setAddressIdentifier(e.currentTarget.value);
          }}
          onFocus={onFocus}
        />
      </Stack.Item>
    );
  }
};
